


















































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'
import {
  BibliographyFullId,
  CollectionFlag,
  defaultBibliographyFullId,
  Prefix
} from '@/types'
import { Emit } from '@/node_modules/nuxt-property-decorator'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'

export interface BibliographyIntegrationInfoTableItem {
  bibliographyFullId: BibliographyFullId
  searchType: SystemCode
  displayMaterialFormat: SystemCode
  displayClass: string
  bibliographySetId: number
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  displayPublished: string
  holdingCount: number
  orderCount: number
  reserveCount: number
  collectionFlag: CollectionFlag
}

export const defaultBibliographyIntegrationInfoTableItem = (): BibliographyIntegrationInfoTableItem => ({
  bibliographyFullId: defaultBibliographyFullId(),
  searchType: defaultSystemCode(),
  displayMaterialFormat: defaultSystemCode(),
  displayClass: '',
  bibliographySetId: 0,
  displayTitle: '',
  displayAuthor: '',
  displayPublisher: '',
  displayPublished: '',
  holdingCount: 0,
  orderCount: 0,
  reserveCount: 0,
  collectionFlag: CollectionFlag.NotCollection
})

@Component({
  components: { IconBibliography }
})
export default class BibliographyIntegrationInfoTable extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: BibliographyIntegrationInfoTableItem

  @Prop({
    type: Boolean,
    default: false
  })
  invisibleCount!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isBibliographyReal!: boolean

  get displayBibliographySetId() {
    if (this.item.bibliographySetId === 0) {
      return ''
    }
    return Prefix.Set + this.item.bibliographySetId.toString().padStart(10, '0')
  }

  get holdingCount(): number | string {
    return this.invisibleCount ? '' : this.item.holdingCount
  }

  get orderCount(): number | string {
    return this.invisibleCount ? '' : this.item.orderCount
  }

  get reserveCount(): number | string {
    return this.invisibleCount ? '' : this.item.reserveCount
  }

  @Emit('link')
  onClickLink(): BibliographyFullId {
    return this.item.bibliographyFullId
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }
}
